<template>
  <d2-container>
    <h2>企业资料审阅</h2>
    <ReviewComponents :activeName="activeName"></ReviewComponents>
  </d2-container>
</template>
<script>
import ReviewComponents from './ReviewComponents.vue'
export default {
  components: {
    ReviewComponents
  },
  data() {
    return {
      activeName:0,
    };
  },
  methods:{
    handleClick:function(tab, event){
      this.$store.commit("authType", tab.name);
    }
  }
};
</script>
